import { useEffect, useState } from "react";
import { saveOfficeDetails } from "../Api/OfficeMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { useAuth } from "../Context/AuthContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";
import { fetchCompnayCodesById,fetchOfficeType } from "../Api/InvoiceApi";
const OfficeMaster = () => {
  const {user}=useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId; 

  const [officeData, setOfficeData] = useState({
    officeCode: "",
    officeName: "",
    officeType: "",
    companyCode: ""
  });
  const [dropdownData, setDropdownData] = useState({
    companyCodes: [],
    officeTypes:[]
  });
  
  const fetchAllData=async()=>{
    const [companyCodes,officeTypes]=await Promise.all([
      fetchCompnayCodesById(user.organisationId),
      fetchOfficeType(user.organisationId)
    ] )

      setDropdownData({
        companyCodes:companyCodes,
        officeTypes:officeTypes
      })
  }


  useEffect(()=>{
    fetchAllData();
  },[])
  console.log(dropdownData.companyCodes,dropdownData.officeTypes);
  // Company code options
  const companyOptions = [
    { value: "1000", label: "1000 - STPL" },
    { value: "2000", label: "2000 - Bizflow" },
    { value: "3000", label: "3000 - Discovery Wines" }
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOfficeData({
      ...officeData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveOfficeDetails(officeData, userId);
      toast.success(`🦄 Office Added Successfully`);
      setOfficeData({
        officeCode: "",
        officeName: "",
        officeType: "",
        companyCode: ""
      });
    } catch (error) {
      toast.error(`🦄 Error: ${error.message || "Failed to save office details"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Office Master</h2>

            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Office Code <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="officeCode"
                      value={officeData.officeCode}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Office Name <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="officeName"
                      value={officeData.officeName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Office Type <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="officeType"
                      value={officeData.officeType}
                      onChange={handleChange}
                      required
                      
                    >
                    <option value="">Select Company</option>
                     {dropdownData.officeTypes.map((option) => (
                        <option key={option.officeCode} value={option.officeCode}>
                          {option.officeCode } - {option.officeDescription}
                        </option>
                      ))}
                      </Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Company Code <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      as="select"
                      name="companyCode"
                      value={officeData.companyCode}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Company</option>
                     {dropdownData.companyCodes.map((option) => (
                        <option key={option.companyCode} value={option.companyCode}>
                          {option.companyCode} - {option.name}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Office
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      
      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default OfficeMaster;